var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { DisplayManagerProvider } from '../../context/display-manager-context';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
import { getGeometryStyle } from '../../helpers/styles';
var TabContainer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background: ", ";\n  display: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  flex-direction: ", ";\n"], ["\n  ", "\n  background: ", ";\n  display: ", ";\n  justify-content: ",
    ";\n  align-items: ", ";\n  flex-direction: ",
    ";\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.justifyContent;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.alignItems;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.flexDirection;
});
var TabNavContainer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", ";\n  color: ", ";\n  width: ", ";\n  display: ", ";\n  justify-content: ", ";\n"], ["\n  height: ", ";\n  color: ", ";\n  width: ", ";\n  display: ", ";\n  justify-content: ",
    ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.justifyContent;
});
var TabNavContainerItem = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  display: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  flex-grow: ", ";\n  text-align: ", ";\n  border: ", ";\n  border-right: ", ";\n  color: ", ";\n  cursor: pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n"], ["\n  ",
    "\n  display: ", ";\n  align-items: ",
    ";\n  justify-content: ",
    ";\n  flex-grow: ", ";\n  text-align: ",
    ";\n  border: ", ";\n  border-right: ",
    ";\n  color: ", ";\n  cursor: pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n"])), function (_a) {
    var active = _a.active, windowTheme = _a.windowTheme;
    return active
        ? "background-color: \n          " + windowTheme.tabNavigator.nav.item.active.backgroundColor + ";"
        : "background-color: \n          " + windowTheme.tabNavigator.nav.item.backgroundColor + ";";
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.alignItems;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.justifyContent;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.flexGrow;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.textAlign;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.borderRight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.color;
});
var TabContent = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: ", ";\n  flex-grow: ", ";\n  width: ", ";\n  border: ", ";\n"], ["\n  position: ",
    ";\n  flex-grow: ",
    ";\n  width: ",
    ";\n  border: ",
    ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.content.position;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.content.flexGrow;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.content.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.content.border;
});
var TabNavigator = function (props) {
    var identifier = props.identifier, type = props.type, children = props.children, attributes = props.attributes, restProps = __rest(props, ["identifier", "type", "children", "attributes"]);
    var currentIndex = attributes.currentIndex, geometry = attributes.geometry;
    var fields = useContext(WindowStateContext).fields;
    var _a = useState(fields.tabId ? "" + (fields === null || fields === void 0 ? void 0 : fields.tabId) : identifier + "_" + currentIndex), activeTab = _a[0], setActiveTab = _a[1];
    var childWidgets = restProps.childWidgets, windowTheme = restProps.windowTheme;
    var _onTabChange = useContext(WindowEventContext)._onTabChange;
    var activeIndex = activeTab
        ? parseInt(activeTab.split('_').pop())
        : currentIndex;
    var tabHeads = childWidgets.map(function (_a, index) {
        var _b = _a.attributes, title = _b.title, name = _b.name;
        var tabId = identifier + "_" + index;
        return (React.createElement(TabNavContainerItem, { id: tabId, key: name, onClick: function () {
                _onTabChange(tabId);
                setActiveTab(tabId);
            }, active: tabId === activeTab, windowTheme: windowTheme }, typeof title === 'string' ? title : title['_']));
    });
    var changeTab = function (tabIndex) {
        var stateObj = {};
        childWidgets.forEach(function (cWidget) {
            stateObj[cWidget.attributes.name] = true;
        });
        var activeTab = childWidgets[tabIndex];
        if (activeTab) {
            stateObj[activeTab.attributes.name] = false;
        }
        setTabManager(stateObj);
    };
    var getSelectedTabContent = function () {
        var activeTab = childWidgets[activeIndex];
        return children.find(function (item) { return activeTab && item.key === activeTab.identifier; });
    };
    useEffect(function () {
        changeTab(activeIndex);
        setSelectedTabContent(getSelectedTabContent());
    }, [activeIndex]);
    useEffect(function () {
        changeTab(currentIndex);
    }, [currentIndex]);
    var _b = useState(getSelectedTabContent()), selectedTabContent = _b[0], setSelectedTabContent = _b[1];
    var _c = useState({}), tabManager = _c[0], setTabManager = _c[1];
    return (React.createElement(DisplayManagerProvider, { value: tabManager },
        React.createElement(TabContainer, __assign({ id: identifier, geometry: geometry }, restProps, { windowTheme: restProps.windowTheme }),
            React.createElement(TabNavContainer, { windowTheme: restProps.windowTheme }, tabHeads),
            React.createElement(TabContent, { windowTheme: restProps.windowTheme }, selectedTabContent))));
};
export default TabNavigator;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map